/**
 * Map a human-readable ticket-status label as rendered on the Reports charts
 * ("New", "In Progress", "Pending", "Resolved") to the enum value the tickets
 * list API validates against ("new", "in_progress", "pending", "resolved").
 *
 * Why this exists: the Overview charts label a slice/bar "In Progress", and the
 * drill-down handlers used a naive `label.toLowerCase()` which yields
 * "in progress" (a space). The ticket-service QueryTicketsDto validates
 * `status` with `@IsEnum(TicketStatus)`, so "in progress" is rejected with a
 * 400 and no tickets load. Single-word statuses (new/pending/resolved) happened
 * to pass, which is why only "In Progress" broke. Normalizing internal
 * whitespace to underscores produces the correct enum value for every status.
 */
export function statusLabelToFilterValue(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, '_');
}
